export const hideLastDigits = (phoneNumber: string) => {
  return phoneNumber.slice(0, -5).concat('XX-XX');
};
